import TmdbService from "../../services/tmdb";

const tmdb = new TmdbService();

export const FETCH_SEARCH = "FETCH_SEARCH";
export const SEARCH_RESULT_LOADED = "SEARCH_RESULT_LOADED";

export const searchResultLoaded = data => {
  return {
    type: SEARCH_RESULT_LOADED,
    payload: data
  };
};

export const fetchSearch = (dispatch, query) => {
  tmdb.searchMovie(query).then(data => dispatch(searchResultLoaded(data)));
};
